import React, { useEffect, useMemo } from 'react';
import FilterDropdown from '../../FilterDropdown/FilterDropdown';
import FilterButton from '../../FilterButton/FilterButton';
import useFilterState from '../../../hooks/useFilterState';
import { filtersData } from '../../../constants/filtersData';
import { filterNames } from '../../../constants/filterNames';
import FilterContainer from '../../FilterContainer/FilterContainer';
import SelectedOption from '../../SelectedOption/SelectedOption';
import { useSelector } from 'react-redux';
import { generateServices } from './utils';
import { HiddenSelectedOptions } from '../../HiddenSelectedOptions/HiddenSelectedOptions';
import { useFilterOptionsShorter } from '../../../hooks/useFilterOptionsShorter';

const filter = filtersData[filterNames.services];

const ServicesFilter = ({ disabled = false }) => {
  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  const [filterState, setFilterState] = useFilterState(filter);
  const filterStateSet = new Set(filterState);
  const hasFilter = filterState.length > 0;

  const items = useMemo(() => {
    if (filteredRequests?.length) {
      const map = new Map();
      filteredRequests.forEach(generateServices(map));
      return Array.from(map.values()).sort((a, b) => b.amount - a.amount);
    }

    return [];
  }, [filteredRequests]);

  const handleItemRemove = (id) => {
    const setClone = new Set(filterStateSet);
    setClone.delete(id);
    setFilterState(Array.from(setClone));
  };

  useEffect(() => {
    if (items.length) {
      const setFilter = (prev) =>
        prev.filter((filterId) => items.some((item) => item.id === filterId));

      setFilterState(setFilter);
    }
  }, [items]);

  const filteredItems = items.filter((item) => filterStateSet.has(item.id));
  const { visibleItems, hiddenItems } = useFilterOptionsShorter(filteredItems);

  return (
    <FilterContainer>
      <FilterDropdown
        disabled={disabled}
        filter={filter}
        items={items}
        getItemContent={(item) => item.name}
        getSearchContent={(item) => item.name}
        renderButton={({ visible }) => (
          <FilterButton
            text="Причина"
            opened={visible}
            selected={hasFilter}
          />
        )}
      />
      {hasFilter &&
        visibleItems.map((item) => (
          <SelectedOption
            key={item.id}
            text={item.name}
            value={item.id}
            onRemove={handleItemRemove}
          />
        ))}
      {Array.isArray(hiddenItems) && !!hiddenItems.length && (
        <HiddenSelectedOptions
          hiddenItems={hiddenItems}
          handleItemRemove={handleItemRemove}
        />
      )}
    </FilterContainer>
  );
};

export default ServicesFilter;
